import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { OfflineScreen } from 'modules/offlineScreen';

const useStyles = makeStyles(() => ({
  root: {
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    flexGrow: 1,
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    height: '100vh'
  }
}));

type PageLayoutContainerProps = {
  children?: React.ReactNode;
};

export const PageLayoutContainer: React.FC = ({
  children
}: PageLayoutContainerProps) => {
  const classes = useStyles();

  return (
    <div data-testid="page-layout-container" className={classes.root}>
      <OfflineScreen />
      {children}
    </div>
  );
};

export default PageLayoutContainer;
